import React from 'react';
import { generatePointLine, calculateNewPoint } from '../utils';
import SvgContentList from './shape/SvgContentList';

const GenerateExternalMaskSvg = ({ shapeInfo, handleClick }: any) => {
  switch (shapeInfo?.type) {
    case 99:
      const outputStrokes = shapeInfo.children.filter((child: any) => child.attributes?.["data-output"] === "stroke");
      if (outputStrokes.length > 0) {
        return (
          <SvgContentList
            shapeInfo={{children: [{
                ...outputStrokes[0],
                attributes: {
                  ...outputStrokes[0].attributes,
                  fill: 'none'
                }
              }],
              transform: {
                x: shapeInfo?.transform?.x,
                y: shapeInfo?.transform?.y
              }
            }}
            drawOutline={true}
          />
        );
      }

      return (
        <></>
      );
    case 100:
      return (
        <>
          <rect
            id="1"
            onClick={handleClick}
            width={shapeInfo?.width}
            height={shapeInfo?.height * 0.9} // because potrace will add extra border so height is bigger than the original height
            x={shapeInfo?.x}
            y={shapeInfo?.y}
            transform={shapeInfo?.transform ? `translate(${shapeInfo?.transform?.x},${shapeInfo?.transform?.y})` : ''}
            stroke="black"
            strokeWidth={1}
            fill="none"
            // mask="url(#tinymask)"
          />
        </>
      );
    case 98:
      return (
        <>
          <polygon
            points={generatePointLine(calculateNewPoint(shapeInfo?.points, shapeInfo?.scale3))}
            transform={shapeInfo?.transform ? `translate(${shapeInfo?.transform?.x},${shapeInfo?.transform?.y})` : ''}
            stroke="none"
            strokeWidth={1}
            mask="url(#tinymask)"
          />
        </>
      );
    default:
      return <></>;
  }
};

export default GenerateExternalMaskSvg;
